export default __webpack_public_path__ + "a4f04778b2ecb5e9fc33b29e3c57a48e.svg";